var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlGolfViewFilled = function SvgHtlGolfViewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 11.5a2.327 2.327 0 0 1 1.537-1.985.499.499 0 0 1 .688.618.5.5 0 0 1-.256.285c-.606.29-.969.695-.969 1.083C3 12.21 4.232 13 6 13s3-.79 3-1.5a1.163 1.163 0 0 0-.378-.81c-.45-.4-1.02-.641-1.622-.684V11.5a.5.5 0 0 1-1 0V2.44a.507.507 0 0 1 .023-.1l.005-.014.005-.013v-.022a.494.494 0 0 1 .15-.182l.007-.005a.5.5 0 0 1 .534-.031l.013.008H6.75l3 2a.5.5 0 0 1 0 .832l-2.777 1.85V9a3.734 3.734 0 0 1 2.326.979 2.122 2.122 0 0 1 .674 1.52c0 1.4-1.757 2.5-4 2.5-2.243 0-3.973-1.1-3.973-2.5Zm9-2a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z"
  })));
};
export default SvgHtlGolfViewFilled;